import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const VimeoCallback: React.FC = () => {
    const location = useLocation();

    useEffect(() => {
        // Extract the authorization code from the URL
        const params = new URLSearchParams(location.search);
        const authorizationCode = params.get('code');

        if (authorizationCode) {
            // Call backend API with the authorization code so backend can call the token endpoint for Access Token and store it.
            // When call is successful user should be redirected back to the master exercise page.

            console.log('Authorization Code:', authorizationCode);
        } else {
            console.log('Authorization Code - Error');
        }
    }, [location]);

    return <div>Vimeo Callback Page - Processing...</div>;
};

export default VimeoCallback;
